// src/routes/PublicRoute.tsx
import { ReactElement } from "react";

type PublicRouteProps = {
  children: ReactElement;
};

const PublicRoute = ({ children }: PublicRouteProps): ReactElement => {
  return children;
};

export default PublicRoute;
